let t = {};
function e() {
  return t;
}
export {
  e as getDefaultOptions
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/date-fns@3.6.0/~/date-fns/_lib/defaultOptions.js
// module id = 208
// module chunks = 67